/**
 * Variables de entorno para ambiente de produccion
 */
export const environment = {
  /**
   * Indica si es produccion o no
   */
  production: true,
  /**
   * Credenciales firebase
   */
  firebase: {
    apiKey: 'AIzaSyDjpXI9UZ-BDSX8D-BD7V2WLCxr8bSCodw',
    authDomain: 'sinmente-4bfad.firebaseapp.com',
    projectId: 'sinmente-4bfad',
    storageBucket: 'sinmente-4bfad.appspot.com',
    messagingSenderId: '350406167142',
    appId: '1:350406167142:web:99d84f2dc62f0177603ba7',
    measurementId: 'G-ZZJ05HEJF4'
  },
  /**
   * Direccion de la api
   */
  apiUrl: 'https://us-central1-sinmente-4bfad.cloudfunctions.net/api'
};
